/*
 * custom-size-row.js
 * -----------------------------------------------------------------------------
 * Zweck: Der Easysize-Button "FIND YOUR SIZE HERE" (#easysize_button) wird von
 * der Easysize-App NICHT in den Theme-App-Block gerendert, sondern fest neben
 * die Groessenauswahl injiziert. Dadurch liegt er ausserhalb der nativen
 * Group-Zeile, in der auch der Avada "MEASUREMENTS"-Button sitzt -> beide Buttons
 * landen in getrennten Zeilen.
 *
 * Diese Datei verschiebt den Easysize-Button in den leeren Easysize-Container
 * INNERHALB der Group-Zeile. Das restliche Layout (horizontal, Ausrichtung,
 * Abstand, "rechts anordnen") bleibt komplett ueber den nativen Group-Block im
 * Theme-Editor steuerbar (content_direction = row, horizontal_alignment =
 * space-between o. Ae.).
 *
 * Easysize setzt den Button bei jedem Varianten-Wechsel neu -> wir re-platzieren
 * ihn ereignisgesteuert und via MutationObserver.
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  // Ziel-Slot: der (leere) Easysize-Container, der bereits IN der Group-Zeile liegt.
  var SLOT_SELECTOR = '.group-block-content .easysize-container';
  var BUTTON_ID = 'easysize_button';

  function relocate() {
    var btn = document.getElementById(BUTTON_ID);
    var slot = document.querySelector(SLOT_SELECTOR);
    if (!btn || !slot) return false;
    if (slot.contains(btn)) return true; // schon am richtigen Platz
    slot.appendChild(btn);
    return true;
  }

  // 1) Initiale Platzierung + Nachlauf, bis Easysize den Button erstmals injiziert hat.
  var tries = 0;
  var interval = window.setInterval(function () {
    relocate();
    if (++tries > 60) window.clearInterval(interval); // ~15s Sicherheitsfenster
  }, 250);

  // 2) Easysize-eigene Refresh-Events (Varianten-Wechsel) -> erneut verschieben.
  ['variant:change', 'variant:selected', 'shopify:section:load'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      window.setTimeout(relocate, 80);
    });
  });

  // 3) Fallback: DOM beobachten, falls Easysize den Button spaeter neu erzeugt.
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () { relocate(); });
    var start = function () {
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
  }
})();
